import { render, staticRenderFns } from "./CustomerOrdersPause.vue?vue&type=template&id=1d9f9f82"
import script from "./CustomerOrdersPause.vue?vue&type=script&lang=js"
export * from "./CustomerOrdersPause.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports